<template>
  <div :class="[{ absolute: absolute }]" class="debug-container">
    <button :class="[{ show: show }]" @click="showDebug">
      Debuginfo<span v-if="title">: {{ title }}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Capa_1"
        width="18"
        height="18"
        viewBox="0 0 456.828 456.828"
      >
        <g fill="#FFF">
          <path
            d="M451.383 247.54c-3.606-3.617-7.898-5.427-12.847-5.427h-63.953v-83.939l49.396-49.394c3.614-3.615 5.428-7.898 5.428-12.85 0-4.947-1.813-9.229-5.428-12.847-3.614-3.616-7.898-5.424-12.847-5.424s-9.233 1.809-12.847 5.424l-49.396 49.394H107.923L58.529 83.083c-3.617-3.616-7.898-5.424-12.847-5.424-4.952 0-9.233 1.809-12.85 5.424-3.617 3.617-5.424 7.9-5.424 12.847 0 4.952 1.807 9.235 5.424 12.85l49.394 49.394v83.939H18.273c-4.949 0-9.231 1.81-12.847 5.427C1.809 251.154 0 255.442 0 260.387c0 4.949 1.809 9.237 5.426 12.848 3.616 3.617 7.898 5.431 12.847 5.431h63.953c0 30.447 5.522 56.53 16.56 78.224l-57.67 64.809c-3.237 3.81-4.712 8.234-4.425 13.275.284 5.037 2.235 9.273 5.852 12.703 3.617 3.045 7.707 4.571 12.275 4.571 5.33 0 9.897-1.991 13.706-5.995l52.246-59.102 4.285 4.004c2.664 2.479 6.801 5.564 12.419 9.274 5.617 3.71 11.897 7.423 18.842 11.143 6.95 3.71 15.23 6.852 24.84 9.418 9.614 2.573 19.273 3.86 28.98 3.86V169.034h36.547V424.85c9.134 0 18.363-1.239 27.688-3.717 9.328-2.471 17.135-5.232 23.418-8.278a180.73 180.73 0 0 0 18.555-10.42c6.092-3.901 10.089-6.612 11.991-8.138 1.909-1.526 3.333-2.762 4.284-3.71l56.534 56.243c3.433 3.617 7.707 5.424 12.847 5.424 5.141 0 9.422-1.807 12.854-5.424 3.607-3.617 5.421-7.902 5.421-12.851s-1.813-9.232-5.421-12.847l-59.388-59.669c12.755-22.651 19.13-50.251 19.13-82.796h63.953c4.949 0 9.236-1.81 12.847-5.427 3.614-3.614 5.432-7.898 5.432-12.847 0-4.948-1.817-9.235-5.445-12.853z"
          />
          <path
            d="M293.081 31.27c-17.795-17.795-39.352-26.696-64.667-26.696-25.319 0-46.87 8.901-64.668 26.696-17.795 17.797-26.691 39.353-26.691 64.667h182.716c0-25.31-8.895-46.87-26.69-64.667z"
          />
        </g>
      </svg>
    </button>
    <transition
      name="accordion"
      v-on:before-enter="beforeEnter"
      v-on:enter="enter"
      v-on:before-leave="beforeLeave"
      v-on:leave="leave"
    >
      <pre v-show="show"><slot></slot></pre>
    </transition>
  </div>
</template>

<script>
export default {
  name: "dump-debug",
  props: ["data", "title", "absolute"],
  data() {
    return {
      show: false
    };
  },
  methods: {
    showDebug() {
      this.show = !this.show;
    },
    beforeEnter: function(el) {
      el.style.height = "0";
    },
    enter: function(el) {
      el.style.height = el.scrollHeight + "px";
    },
    beforeLeave: function(el) {
      el.style.height = el.scrollHeight + "px";
    },
    leave: function(el) {
      el.style.height = "0";
    }
  },
  computed: {}
};
</script>

<style lang="scss" scope>
.debug-container {
  background: #32313e;
  display: inline-block;
  border-radius: 3px;
  z-index: 9999;
  min-width: 150px;
  position: relative;
  margin: 20px 0;
  &.absolute {
    top: 0px;
    left: 0;
    margin: 0;
    position: absolute;
    button {
      transform: translateX(-88%);
      transform: translateX(calc(-100% + 28px));
    }
  }
  svg {
    position: relative;
    top: 1px;
    margin-left: 6px;
    height: 14px;
  }
  button {
    text-transform: uppercase;
    background: #673ab7;
    border: 1px solid #ffffff;
    color: #fff;
    /* font-weight: bold; */
    padding: 8px 7px;
    font-size: 12px;
    position: absolute;
    top: -14px;
    white-space: nowrap;
    z-index: 9999;

    cursor: pointer;
    line-height: 1;
    transition: 0.2s ease-in-out;
    &:hover,
    &.show {
      transform: translateX(0);
      background-color: #ff5722;
    }
  }
  pre {
    padding: 15px;
    padding-top: 30px;
    padding-left: 30px;
    left: 15px;
    margin: 0;
    border-radius: 3px;
    position: absolute;
    z-index: 9998;
    background: #32313d;
    color: #fff;
    will-change: height;
    transform: translateZ(0);
    backface-visibility: hidden;
    perspective: 1000px;
    transition: 150ms ease-out;
  }
}
</style>
